export default "__VITE_ASSET__CAPmU9NX__"